<div class="innerpage-fullwithbanner">
  <h2 class="bighead">User Portfolios</h2>
  <ul class="bread-crumbs">
    <li><a (click)="_ValidationService.redirect('/')">Home<span>|</span></a></li>
    <li>Portfolios<span style="padding:8px;">|</span></li>
    <li>User Portfolios</li>
  </ul>
</div>
<div class="container container-lg section-margin min-heightcontainer p_1">
  <div class="border-div table-fixed margin0">
    <div class="tabstyle2 offerdetailstab-padding pos-relative">
      <ul class="switchingproperty margin-bottom-15 offerlistingtab">
        <li [class.active]="activePortfolioTab == portfolioTabs.Access">
          <a href="javascript:void(0);" (click)="onPortfolioTabClick(portfolioTabs.Access)">
            Access
          </a>
        </li>
        <li [class.active]="activePortfolioTab == portfolioTabs.NoAccess">
          <a href="javascript:void(0);" (click)="onPortfolioTabClick(portfolioTabs.NoAccess)">
            No Access
          </a>
        </li>

      </ul>
      <div class="d-flex margin-bottom-15">
        <div class="ml-auto d-flex">
          <div class="search-sec margin-right-20">
            <input class="form-control" [(ngModel)]="searchText" type="text" maxlength="30" (keyup)='search($event.target.value)' placeholder="Search">
            <i class="fa fa-search icon" aria-hidden="true"></i>
          </div>

        </div>
      </div>
    </div>
    
    <div class="cf list-table">
      <div class="table-responsive">
        <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th>
                Name
              </th>
              <th data-orderable="false">
                Portfolio
              </th>
              <th>
                Company
              </th>
              <th>
                Role
              </th>
              <th data-orderable="false">
                Properties
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let deal of filterData; let i=index">
              <td>
                <p class="d-flex"><a href="javascript:void(0);" routerLink="/registered-user-details/" [queryParams]="{principal:deal.UserGuid,prevPage:'User Portfolios',prevPageRouteLink:'/view-portfolio'}"> {{deal.FirstName}} {{deal.LastName}}</a></p>
                {{deal.Phone|phone}}<br />
                {{deal.Email}}
              </td>
              <td class="whitespacenowrap" (click)="redirectOnCellClick(deal.UserGuid)" style="cursor:pointer;">
                <p class="d-flex">
                  <a href="javascript:void(0)">
                    View
                  </a>
                </p>
              </td>
              <td>{{deal.Company}}</td>
              <td>{{deal.UserRole}}</td>
              <td>
                Portfolio - {{deal.PortfolioCount}}<br />
                Off-Market - {{deal.OffMarketCount}}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr *ngIf="filterData?.length == 0&&!IsLoading ">
              <td colspan="8" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No Data Available</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
